// extracted by mini-css-extract-plugin
export default {"allReviews__content":"AllReviews_allReviews__content__PlRvO","allReviews":"AllReviews_allReviews__fs0fU"};